module.exports = "<navigation [topNav]=\"moduleName\" [subNavs]=\"modules\"></navigation>"